import React from 'react';
import View from 'components/View';
import Image from 'components/Image';
import CoachingHelpHeader from 'coaching/components/CoachingHelpFormView/CoachingHelpHeader';
import CoachingCoachHelpHomeIntro from 'coaching/components/CoachingCoachHelpFormView/CoachingCoachHelpHomeIntro';
import CoachingCoachHelpContactSection from 'coaching/components/CoachingCoachHelpFormView/CoachingCoachHelpContactSection';
import CoachingCoachHelpAdditionalResourcesSection from 'coaching/components/CoachingCoachHelpFormView/CoachingCoachHelpAdditionalResourcesSection';
import CoachingCoachHelpEmailSection from 'coaching/components/CoachingCoachHelpFormView/CoachingCoachHelpEmailSection';
import { GetCoachingHelpForm_me } from 'coaching/queries/__generated__/GetCoachingHelpForm';

import 'coaching/components/styles/CoachingCoachHelpHomeView.scss';

type Props = {
  me: GetCoachingHelpForm_me | null | undefined;
};

export default function CoachingCoachHelpHomeView(props: Props) {
  const isAuthenticated = !!props.me;
  const firstName = props.me?.first_name ?? undefined;
  const lastName = props.me?.last_name ?? undefined;

  return (
    <React.Fragment>
      <CoachingHelpHeader
        showLoginButton={!isAuthenticated}
        firstName={firstName}
        lastName={lastName}
      />
      <View className="CoachingCoachHelpHomeView CoachingCoachHelpHomeView--lighter">
        <CoachingCoachHelpHomeIntro />
      </View>
      <View className="CoachingCoachHelpHomeView CoachingCoachHelpHomeView--lighter">
        <CoachingCoachHelpContactSection />
      </View>
      <View className="CoachingCoachHelpHomeView CoachingCoachHelpHomeView--darker">
        <CoachingCoachHelpAdditionalResourcesSection />
      </View>
      <View className="CoachingCoachHelpHomeView CoachingCoachHelpHomeView--lighter">
        <CoachingCoachHelpEmailSection />
      </View>
      <div className="CoachingCoachHelpHomeView CoachingCoachHelpHomeView-footer CoachingCoachHelpHomeView--lighter">
        <Image src={require('assets/images/coaching/school_doodle.png')} />
      </div>
    </React.Fragment>
  );
}
